/**
 * Created by cahyo wibowo on 1/4/19
 */

export default (value: string) => {
  return (value.charAt(0).toUpperCase() + value.slice(1)).split(/(?=[A-Z 0-9])/)
    .filter(item => item).join(' ');
}
